import React, { useState, useCallback, useEffect } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardBody, Button } from "reactstrap";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { convertToBase64, getFileSize } from "../utils";
import LoadingButton from "../components/LoadingButton";
import { useProfile } from "../api/hooks/profile";

// import { createTemplate } from "../api/actions/templates";
import { createContract } from "../api/actions/contracts";
import useFileUpload from "../api/hooks/useFileUpload";
import { fetcher } from "../api/client";

import fileUpload from "../images/pdf/file-upload.svg";

function UploadPDFContainer({ className }) {
  const { t } = useTranslation("common");
  const history = useHistory();

  // const [editorState, editorDispatch] = useEditor();
  const [files, setFiles] = useState([]);
  const { profile } = useProfile();
  const hasFiles = !!files.length;

  // const { mutate: createTemplateMutate, loading: creatingTemplate, payload: createTemplatePayload } = useMutation(createTemplate)
  const { mutate: mutateCreateContract, isLoading: creatingContract } =
    useMutation((payload) => fetcher(createContract(payload)), {
      onSuccess: ({ data }) => {
        setFiles([]);
        // editorDispatch({ type: SET_DOCUMENT, document: createContractPayload?.data, setOriginal: true })
        history.replace(`/documents/${data._id}/edit`);
        // history.push(`/documents/${createContractPayoadinoad?.data?._id}/edit`)
      },
      onError: () => {
        toast.error(t("errorMessages.templateUploaded"));
      },
    });
  const { uploadFile, uploadFileState } = useFileUpload({
    onSuccess: ({ url, BaseFileName, fileId }) => {
      mutateCreateContract({
        name: BaseFileName,
        fileId,
        url,
      });
    },
    onError: (error) => {
      toast.error(
        t(`errors.${error?.message}`, t("errorMessages.generalError"))
      );
    },
  });

  const onDrop = useCallback((acceptedFiles) => {
    setFiles(
      acceptedFiles.map((file) => {
        const fileSize = getFileSize(file.size);

        return Object.assign(file, {
          fileSize: `${fileSize.amount.toFixed(2)} ${fileSize.type}`,
        });
      })
    );
  }, []);
  const { getRootProps, getInputProps } = useDropzone({
    accept: "application/pdf",
    onDrop,
  });

  const handleResetUploader = () => {
    setFiles([]);
  };

  const handleUpload = async () => {
    // if (isTemplate) {
    //     const { error: createTemplateMutateError } = await createTemplateMutate(file);
    //     mutateError = createTemplateMutateError;
    // } else {
    let type = 1;
    let hasNoCredits = false;
    if (
      profile?.externalStorageConfig?.saveOn === "trato" &&
      profile?.storage?.remaining <= 0
    ) {
      return toast.error(t("noMoreStorage"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    if (profile.nom151.remaining <= 0 && profile.contracts.remaining <= 0) {
      hasNoCredits = true;
    }
    console.log({ hasNoCredits });

    if (hasNoCredits) {
      return toast.error(t("noMoreCredits"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    console.log({ files, file: files[0] });
    uploadFile({ file: files[0] });
  };

  return (
    <Card className={`mx-auto border-0 shadow-sm ${className}`}>
      <CardBody className="text-center pt-4 px-5 pb-5">
        <h2 className="font-weight-bold mb-0">{t("uploadFile.title")}</h2>
        <p className="text-muted">{t("uploadFile.subtitle")}</p>
        <p className="text-muted">{t("uploadFile.subtitle2")}</p>
        {!hasFiles && (
          <div className="custom-file-upload" {...getRootProps()}>
            <div className="upload-photo">
              <img
                src={fileUpload}
                className="img-fluid icon mb-4"
                alt="upload file"
              />
              <p className="text-muted mb-0">{t("uploadFile.dragFile")}</p>
              <small className="d-block text-primary mb-3">
                {t("uploadFile.orUseButton")}>
              </small>
              <Button color="primary-gradient" className="shadow-sm">
                {t("actions.uploadDocument")}
              </Button>
              <input
                type="file"
                name="photo"
                id="upload-photo"
                {...getInputProps()}
              />
            </div>
          </div>
        )}
        {files?.map((file) => (
          <div
            className="d-flex mb-1 mr-1 align-items-center justify-content rounded p-3 bg-grey"
            key={file.name}
          >
            <FontAwesomeIcon className="color-accent" icon="file" size="2x" />
            <div className="d-flex flex-column ml-3">
              <span>{file.name}</span>
              <span className="text-muted">{file.fileSize}</span>
            </div>
          </div>
        ))}
        {hasFiles && (
          <div className="mt-2">
            <Button
              className="shadow-sm"
              size="sm"
              disabled={creatingContract || uploadFileState.isLoading}
              onClick={handleResetUploader}
            >
              {t("actions.changeDocument")}
            </Button>
            <LoadingButton
              className="shadow-sm ml-2"
              loading={creatingContract || uploadFileState.isLoading}
              loadingText={t("actions.uploading")}
              color="accent"
              size="sm"
              spinnerProps={{
                color: "accent",
              }}
              onClick={handleUpload}
            >
              {t("actions.sendContract")}
            </LoadingButton>
          </div>
        )}
      </CardBody>
    </Card>
  );
}

export default UploadPDFContainer;
